import { INITIALIZE_ECCC_FLAG } from "../actions/actionTypes";
const intialState = {
  pgaflags: [],
};

const EcccFlagReducer = (state = intialState, action) => {
  switch (action.type) {
    case INITIALIZE_ECCC_FLAG:
      return {
        pgaflags: action.payload,
      };

    default:
      return state;
  }
};
export default EcccFlagReducer;
